/// <amd-module name="Core/Medius.Core.Web/Scripts/errorPages/LoginError"/>
import * as React from "react";
import Card from "Core/Medius.Core.Web/Scripts/components/card/Card";
import {toAction} from "Core/Medius.Core.Web/Scripts/Medius/lib/path";
import {translate} from "Core/Medius.Core.Web/Scripts/lib/globalization";

export default function LoginError(props: ILoginError) {
    return (
        <Card>
            <div className="card-content">
                <div className="login-error-page">
                    <div className="login-error-page__title">
                        {"We failed logging you in with the selected provider."}
                    </div>

                    <div className="login-error-page__message">
                        <p>
                            {props.model.Title}
                        </p>
                        <p>
                            {props.model.ErrorMessage}                                                
                        </p>
                    </div>

                    <form action={toAction('SwitchProvider', '~/Account')}>
                        <button className="card-button" type="submit">
                            {translate("#Core/backToLogin")}
                        </button>
                    </form>
                </div>
            </div>
        </Card>
    );
}

interface ILoginError {
    model: { 
        Title: string;
        ClientId: string;
        ErrorMessage: string;
    };
}
